import { render, staticRenderFns } from "./SeeYouSoon.vue?vue&type=template&id=8a122ca6&scoped=true"
import script from "./SeeYouSoon.vue?vue&type=script&lang=js"
export * from "./SeeYouSoon.vue?vue&type=script&lang=js"
import style0 from "./SeeYouSoon.vue?vue&type=style&index=0&id=8a122ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a122ca6",
  null
  
)

export default component.exports